module.exports = __webpack_public_path__ + "static/img/inmueble_category.3d800ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/old/inmueble_category.jpg
// module id = ZEcQ
// module chunks = 1